import { Component, inject, Input, OnInit } from '@angular/core';
import { EstimationTunnelService } from '../../../../services/estimation-tunnel.service';
import { ITransportConfiguration } from '../../../../models/transport-configuration.model';
import { TransportConfigurationService } from '../../../../services/transport-configuration.service';
import { IRegisteredAddress } from '../../../../models/registered-address.model';
import { AccountService } from '../../../../services/account.service';
import { combineLatest } from 'rxjs';
import { TransportFormGroup } from '../../../../models/forms/TransportFormGroup';
import { CurrentDataService } from '../../../../services/current-data-service';
import { TransportStep } from '../../../../models/enums/transport-step.enum';
import { Transport } from '../../../../models/transport.model';
import { Transporter } from '../../../../models/transporter.model';

@Component({
  selector: 'jhi-estimation-delivery-step',
  templateUrl: './estimation-delivery-step.component.html',
})
export class EstimationDeliveryStepComponent implements OnInit {
  readonly #estimationService = inject(EstimationTunnelService);
  readonly #accountService = inject(AccountService);
  readonly #currentDataService = inject(CurrentDataService);
  readonly #transportConfigurationService = inject(TransportConfigurationService);

  @Input() readonly transport!: Transport;
  @Input() transportForm!: TransportFormGroup;
  @Input() isAuthenticated = false;

  public selectedAddress?: IRegisteredAddress;
  public isUser?: boolean;
  public transportConfiguration?: ITransportConfiguration;
  public transporter?: Transporter;

  public ngOnInit(): void {
    this.#estimationService.scrollToTop();
    this.isUser = this.#accountService.hasAnyAuthority('ROLE_USER');
    this.transportForm.controls.offerId?.valueChanges.subscribe((newOfferId: number) => {
      this.#transportConfigurationService.getParams(newOfferId, TransportStep.DELIVERY).subscribe(config => {
        this.transportConfiguration = config;
      });
    });
    combineLatest([this.#currentDataService.getCurrentTransporter(), this.#transportConfigurationService.getParams(this.transport.offerId!, TransportStep.DELIVERY)]).subscribe({
      next: data => {
        this.transporter = data[0];
        this.transportConfiguration = data[1];
      },
    });
  }

  public selectRegisteredAddress(registeredAddress?: IRegisteredAddress): void {
    if (registeredAddress) {
      this.transportForm.updateFormFromRegisteredAddress(registeredAddress, false);
      this.transportForm.getAngularForm().updateValueAndValidity();
    }
    this.selectedAddress = registeredAddress;
  }

  public selectAccessConstraint(accessConstraint?: string): void {
    if (accessConstraint) {
      this.transportForm.updateAccessConstraint(accessConstraint, false);
      this.transportForm.getAngularForm().updateValueAndValidity();
    }
  }

  public selectLoadingConstraint(loadingConstraint?: string): void {
    if (loadingConstraint) {
      this.transportForm.updateLoadingConstraint(loadingConstraint, false);
      this.transportForm.getAngularForm().updateValueAndValidity();
    }
  }
}
